"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LOCALE_CULTURE = exports.DECIMAL_TYPE = exports.CURRENCY_CODE = void 0;
var _react = require("react");
var _reactImageFileResizer = _interopRequireDefault(require("react-image-file-resizer"));
var _dateFns = require("date-fns");
const DATE_FORMAT = {
  SDF: 'dd/MM/yyyy'
};
const CURRENCY_CODE = exports.CURRENCY_CODE = {
  INDONESIAN_RUPIAH: 'IDR',
  JAPANESE_YEN: 'JPY',
  KOREAN_WON: 'KRW',
  INDIAN_RUPEE: 'INR',
  MALAYSIAN_RINGGIT: 'MYR',
  PHILIPPINE_PESO: 'PHP',
  VIETNAMESE_DONG: 'VND'
};
const LOCALE_CULTURE = exports.LOCALE_CULTURE = {
  THAI_CULTURE: 'en-tt',
  THAI_HEADER_CC: 'th-th',
  JAPAN_CULTURE: 'ja-jp',
  KOREA_CULTURE: 'ko-kr',
  CHINA_CULTURE: 'zh-cn',
  TAIWAN_CULTURE: 'zh-tw',
  HONGKONG_CULTURE: 'zh-hk',
  THAILAND_CULTURE: 'en-tt',
  VIETNAMESE_CULTURE: 'vi-vn',
  INDONESIAN_CULTURE: 'id-id',
  MALAYSIA_CULTURE: 'ms-my'
};
const DECIMAL_TYPE = exports.DECIMAL_TYPE = {
  FLOAT: 'FLOAT',
  ROUND: 'ROUND',
  FLOOR: 'FLOOR',
  CEIL: 'CEIL'
};
const PhoenixUtil = {
  keyDownHandler: (e, callBack, keyCode) => {
    if (!e || !callBack || !keyCode) {
      return;
    }
    if (Array.isArray(keyCode)) {
      if (keyCode.includes(e.keyCode)) {
        callBack(e.keyCode);
      }
    } else if (e.keyCode === keyCode) {
      e.preventDefault();
      callBack();
    }
  },
  // eslint-disable-next-line consistent-return
  getCookie: name => {
    if (typeof document !== 'undefined') {
      const value = "; ".concat(document.cookie);
      const parts = value.split("; ".concat(name, "="));
      if (parts.length > 1) return parts.pop().split(';').shift() || '';
    }
  },
  getLocalStorage: name => {
    if (localStorage && name) {
      return localStorage.getItem(name);
    }
    return null;
  },
  setLocalStorage: (name, value) => {
    if (localStorage && name) {
      localStorage.setItem(name, value);
    }
  },
  removeLocalStorage: name => {
    if (localStorage && name) {
      return localStorage.removeItem(name);
    }
    return null;
  },
  trapFocus: (e, parentRef, toFocusRef, toFocusElement) => {
    if (!e || !parentRef) {
      return;
    }
    if (!parentRef.current.contains(e.relatedTarget)) {
      if (toFocusRef && toFocusRef.current) {
        toFocusRef.current.focus();
      } else if (toFocusElement) {
        toFocusElement.focus();
      }
    }
  },
  outsideOfParent: (e, parentRef, callBack) => {
    if (!e || !(parentRef !== null && parentRef !== void 0 && parentRef.current)) {
      return;
    }
    if (!parentRef.current.contains(e.relatedTarget || e.target)) {
      callBack();
    }
  },
  /**
   * Waits for an element satisfying selector to exist, then resolves promise with the element.
   *
   * @param selector
   * @returns {Promise}
   */
  elementReady: selector => {
    return new Promise(resolve => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
      }
      new MutationObserver((mutationRecords, observer) => {
        // Query for elements matching the specified selector
        Array.from(document.querySelectorAll(selector)).forEach(element => {
          resolve(element);
          // Once we have resolved we don't need the observer anymore.
          observer.disconnect();
        });
      }).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    });
  },
  isChinaDomainName: () => {
    if (typeof window !== 'undefined') {
      var _window$location$host;
      return (_window$location$host = window.location.hostname) === null || _window$location$host === void 0 ? void 0 : _window$location$host.includes('airasia.cn');
    }
    return false;
  },
  isLocalEnvironment: () => {
    return window && (window.location.hostname.indexOf('local.airasia.com') > -1 || window.location.hostname.indexOf('localhost') > -1 || window.location.hostname.indexOf('local.airasia.cn') > -1);
  },
  validateEmail: email => {
    // eslint-disable-next-line max-len
    const reg =
    // eslint-disable-next-line max-len
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(String(email).toLowerCase());
  },
  validateURL: string => {
    try {
      return Boolean(new URL(string));
    } catch (e) {
      return false;
    }
  },
  /**
   * Hook that alerts clicks outside of the passed ref
   */
  useOutsideClickHandler: (ref, callback) => {
    (0, _react.useEffect)(() => {
      /**
       * close passenger selection modal if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      }
      if (document != null) document.addEventListener('mousedown', handleClickOutside);
      return () => {
        if (document != null) document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [callback, ref]);
  },
  checkStringBoolean: val => {
    return val.toLowerCase() === 'true';
  },
  getLocaleCode: localeString => {
    const localeArr = localeString.split('-');
    return localeArr[0];
  },
  get: (url, headers) => {
    if (typeof fetch !== 'function') {
      return;
    }

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'GET',
        headers
      }).then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return reject(response);
      }).then(data => {
        resolve(data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  post: (url, headers, payload) => {
    if (typeof fetch !== 'function') {
      return;
    }

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers
      }).then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return reject(response);
      }).then(data => {
        resolve(data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  postText: (url, headers, payload) => {
    if (typeof fetch !== 'function') {
      return;
    }

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers
      }).then(response => {
        if (response.status === 200) {
          return response.text();
        }
        return reject(response);
      }).then(data => {
        resolve(data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  postForm: (url, headers, payload) => {
    if (typeof fetch !== 'function') {
      return;
    }

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        body: payload,
        headers
      }).then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return reject(response);
      }).then(data => {
        resolve(data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getBrowserInfo: () => {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE ".concat(tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    // eslint-disable-next-line no-cond-assign
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  },
  getScreenWidth: () => {
    return window.innerWidth;
  },
  replacedAll: widgetname => {
    let wname;
    if (widgetname != null) {
      wname = widgetname.replace(/ /g, '_');
    }
    return wname;
  },
  /**
   *
   * @param hour
   * @param minute
   * @param language
   * returns formated date e.g 1h 10m
   */
  constructDuration: (hour, minute, language) => {
    if (hour === 0 && minute === 0) {
      return '';
    }
    if (hour === 0) {
      return "".concat(minute).concat(language.minute);
    }
    if (minute === 0) {
      return "".concat(hour).concat(language.hour);
    }
    return "".concat(hour).concat(language.hour, " ").concat(minute).concat(language.minute);
  },
  /**
   * @param element
   *
   * returns the offset of the element {top, left}
   */
  getElementOffset: element => {
    const {
      top,
      left,
      bottom,
      right
    } = element.getBoundingClientRect();
    let {
      scrollLeft,
      scrollTop
    } = document.documentElement;
    if (typeof window !== 'undefined') {
      scrollLeft = window.pageXOffset;
      scrollTop = window.pageYOffset;
    }
    return {
      top: top + scrollTop,
      left: left + scrollLeft,
      bottom,
      right
    };
  },
  resizeFile: file => {
    return new Promise(resolve => {
      _reactImageFileResizer.default.imageFileResizer(file, 300, 400, 'JPEG', 80, 0, uri => {
        resolve(uri);
      }, 'base64');
    });
  },
  dataURIToFile: (dataURI, name) => {
    const splitDataURI = dataURI.split(',');
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
    return new File([new Blob([ia], {
      type: mimeString
    })], name);
  },
  transformText: (string, data) => {
    let newString = string;
    for (let i = 0; i < data.length; i += 1) {
      newString = newString.replace("{".concat(i, "}"), data[i]);
    }
    return newString;
  },
  formatAmount: (value, decimal, currency) => {
    const amountStr = Number(value).toFixed(decimal);
    if ([CURRENCY_CODE.INDONESIAN_RUPIAH, CURRENCY_CODE.JAPANESE_YEN, CURRENCY_CODE.KOREAN_WON, CURRENCY_CODE.VIETNAMESE_DONG].includes(currency.toUpperCase())) {
      let localeString;
      switch (currency) {
        case CURRENCY_CODE.JAPANESE_YEN:
          localeString = LOCALE_CULTURE.JAPAN_CULTURE;
          break;
        case CURRENCY_CODE.KOREAN_WON:
          localeString = LOCALE_CULTURE.KOREA_CULTURE;
          break;
        case CURRENCY_CODE.VIETNAMESE_DONG:
          localeString = LOCALE_CULTURE.VIETNAMESE_CULTURE;
          break;
        default:
          localeString = LOCALE_CULTURE.INDONESIAN_CULTURE;
          break;
      }
      const val = Math.ceil(Number(amountStr));
      return Number(val).toLocaleString(localeString, {
        minimumFractionDigits: 0
      });
    }
    return Number(amountStr).toLocaleString(currency, {
      minimumFractionDigits: decimal
    });
  },
  // eslint-disable-next-line consistent-return
  checkQuantumMetricType: (enableQuantumMetrics, quantumMetricType) => {
    if (!enableQuantumMetrics) {
      return {};
    }
    switch (quantumMetricType) {
      case 'encrypt':
        // eslint-disable-next-line consistent-return
        return {
          'data-qm-encrypt': true
        };
      case 'block':
        // eslint-disable-next-line consistent-return
        return {
          'data-qm-block': true
        };
      default:
        break;
    }
  },
  addMonthToDate: (date, toAdd) => {
    return new Date(date.getFullYear(), date.getMonth() + toAdd, 1);
  },
  isMonthSame: (date1, date2) => {
    return date1.getMonth() === date2.getMonth();
  },
  isDateAhead: (date1, date2) => {
    return date1.setHours(0, 0, 0, 0) > date2.setHours(0, 0, 0, 0);
  },
  getBeginDate: d => {
    const beginDate = (0, _dateFns.format)(PhoenixUtil.isMonthSame(d, new Date()) || PhoenixUtil.isDateAhead(new Date(), d) ? new Date() : d, DATE_FORMAT.SDF);
    const dateArr = beginDate.split('/');
    return PhoenixUtil.isMonthSame(d, new Date()) || PhoenixUtil.isDateAhead(new Date(), d) ? beginDate : "01/".concat(dateArr[1], "/").concat(dateArr[2]);
  },
  getEndDate: (d, limitDateObj) => {
    const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    const finalEndDate = PhoenixUtil.isDateAhead(lastDay, limitDateObj) ? limitDateObj : lastDay;
    return (0, _dateFns.format)(finalEndDate, DATE_FORMAT.SDF);
  },
  formatStringWithLink: function (stringValue) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!stringValue && !args) {
      return [];
    }
    let textHolder = stringValue;
    const newArr = args.map((arg, i) => {
      const [currText, nextText = ''] = textHolder.split("{".concat(i, "}"));
      textHolder = nextText;
      return [currText, arg];
    });
    const mergedArray = [].concat([], ...newArr);
    if (textHolder) {
      mergedArray.push(textHolder);
    }
    return mergedArray;
  },
  removeObject: (data, key) => {
    const hasObjectKey = Object.prototype.hasOwnProperty.call(data, key);
    if (hasObjectKey) {
      delete data[key];
    }
    return data;
  },
  getConvertedCurrency: (baseCurrencyAmount, transactionCurrency, currencyRates) => {
    if (!transactionCurrency) return baseCurrencyAmount;
    return currencyRates && currencyRates[transactionCurrency.toString()] ? baseCurrencyAmount * currencyRates[transactionCurrency.toString()] : baseCurrencyAmount;
  },
  roundToTwo: num => {
    return +"".concat(Math.round("".concat(num, "e+2")), "e-2");
  },
  currencyFormat: (amount, decimalType) => {
    const newAmount = amount !== null && amount !== void 0 ? amount : 0;
    const priceInNumber = newAmount * 1; // conver string to number
    let price = priceInNumber;
    switch (decimalType) {
      case DECIMAL_TYPE.FLOAT:
        price = priceInNumber.toFixed(2);
        break;
      case DECIMAL_TYPE.ROUND:
        price = Math.round(priceInNumber);
        break;
      case DECIMAL_TYPE.FLOOR:
        price = Math.floor(priceInNumber);
        break;
      case DECIMAL_TYPE.CEIL:
        price = Math.ceil(priceInNumber);
        break;
      default:
        price = Number(newAmount);
        price = PhoenixUtil.roundToTwo(price);
    }
    return price;
  }
};
var _default = exports.default = PhoenixUtil;